import type { TableSettings } from '@ipfabric/utils';
import type { TableCommandFactory } from 'components/Table/model/TableModel';

type UpdateExternalTableSettingsCommand = {
  settings: TableSettings;
};

export const applyTableSettings: TableCommandFactory<
  UpdateExternalTableSettingsCommand
> = (cmdContext) => (command) => {
  cmdContext.updateState((draft) => {
    draft.settings = command.settings;
  });
};
